<section class="min-h-screen flex items-center justify-center p-4">
  <div
    class="absolute inset-0 w-full h-full bg-warm-gold/10 blur-3xl animate-spin-slow z-0"
  ></div>

  <app-galaxy-card class="w-full max-w-2xl animate-fade-slide-up" padding="lg">
    <div galaxy-card-content>
      <div class="text-center mb-8">
        <h2 class="text-3xl sm:text-4xl font-bold text-gray-100">
          Únete a Altair Parfum
        </h2>
        <p class="text-gray-400 mt-2">
          Crea tu cuenta para descubrir fragancias árabes y dupes de lujo
        </p>
      </div>

      <form
        [formGroup]="registrationForm"
        (ngSubmit)="register()"
        class="space-y-4"
      >
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
          <!-- Username -->
          <div>
            <label
              for="username"
              class="block mb-2 text-sm font-medium text-gray-300"
              >Username</label
            >
            <input
              formControlName="username"
              type="text"
              placeholder="Elige un alias"
              class="glass-input"
            />
            @if (
              f["username"].invalid &&
              (f["username"].dirty || f["username"].touched)
            ) {
              <div class="text-red-400 text-sm mt-2 font-medium">
                @if (f["username"].errors?.["required"]) {
                  <div>El username es requerido.</div>
                }
              </div>
            }
          </div>

          <!-- First Name -->
          <div>
            <label
              for="firstName"
              class="block mb-2 text-sm font-medium text-gray-300"
              >Nombre</label
            >
            <input
              formControlName="firstName"
              type="text"
              placeholder="Tu nombre"
              class="glass-input"
            />
            @if (
              f["firstName"].invalid &&
              (f["firstName"].dirty || f["firstName"].touched)
            ) {
              <div class="text-red-400 text-sm mt-2 font-medium">
                @if (f["firstName"].errors?.["required"]) {
                  <div>El nombre es requerido.</div>
                }
              </div>
            }
          </div>

          <!-- Last Name -->
          <div>
            <label
              for="lastName"
              class="block mb-2 text-sm font-medium text-gray-300"
              >Apellido</label
            >
            <input
              formControlName="lastName"
              type="text"
              placeholder="Tu apellido"
              class="glass-input"
            />
            @if (
              f["lastName"].invalid &&
              (f["lastName"].dirty || f["lastName"].touched)
            ) {
              <div class="text-red-400 text-sm mt-2 font-medium">
                @if (f["lastName"].errors?.["required"]) {
                  <div>El apellido es requerido.</div>
                }
              </div>
            }
          </div>

          <!-- Email -->
          <div>
            <label
              for="email"
              class="block mb-2 text-sm font-medium text-gray-300"
              >Email</label
            >
            <input
              formControlName="email"
              type="email"
              placeholder="tu@email.com"
              class="glass-input"
            />
            @if (
              f["email"].invalid && (f["email"].dirty || f["email"].touched)
            ) {
              <div class="text-red-400 text-sm mt-2 font-medium">
                @if (f["email"].errors?.["required"]) {
                  <div>El email es requerido.</div>
                }
              </div>
            }
          </div>

          <!-- Address -->
          <div class="md:col-span-2">
            <label
              for="address"
              class="block mb-2 text-sm font-medium text-gray-300"
              >Dirección</label
            >
            <input
              formControlName="address"
              type="text"
              placeholder="Dirección de envío"
              class="glass-input"
            />
          </div>

          <!-- Cellphone -->
          <div>
            <label
              for="cellphone"
              class="block mb-2 text-sm font-medium text-gray-300"
              >Celular</label
            >
            <input
              formControlName="cellphone"
              type="tel"
              placeholder="Tu número de celular"
              class="glass-input"
            />
          </div>

          <!-- Password -->
          <div>
            <label
              for="password"
              class="block mb-2 text-sm font-medium text-gray-300"
              >Contraseña</label
            >
            <input
              formControlName="password"
              type="password"
              placeholder="Mínimo 6 caracteres"
              class="glass-input"
            />
            @if (
              f["password"].invalid &&
              (f["password"].dirty || f["password"].touched)
            ) {
              <div class="text-red-400 text-sm mt-2 font-medium">
                @if (f["password"].errors?.["required"]) {
                  <div>La contraseña es requerida.</div>
                }
                @if (f["password"].errors?.["minlength"]) {
                  <div>Debe tener al menos 6 caracteres.</div>
                }
              </div>
            }
          </div>
        </div>

        <!-- Botón de Registro con Directiva Galaxy -->
        <div class="pt-4">
          <button
            type="submit"
            [disabled]="registrationForm.invalid"
            appGalaxyButton
            appGalaxyRipple
            class="w-full galaxy-variant-primary galaxy-size-md mb-4"
          >
            Crear Cuenta
          </button>
          
          <div class="relative flex items-center justify-center my-4">
            <span class="absolute px-2 bg-smoked-slate text-gray-400 text-sm">O regístrate con</span>
            <div class="w-full border-t border-gray-600"></div>
          </div>
          
          <div id="google-btn-register-container" class="w-full flex justify-center mt-4"></div>
        </div>
      </form>

      <!-- Enlace a Login -->
      <div class="text-center mt-6">
        <span class="text-gray-400">¿Ya tienes una cuenta? </span>
        <a
          [routerLink]="['/user/login']"
          class="font-medium text-violet-400 hover:text-violet-300 transition-colors duration-300"
        >
          Ingresa aquí
        </a>
      </div>
    </div>
  </app-galaxy-card>
</section>
